import React from 'react';
import classNames from 'classnames';
import { CloseOutlined } from 'jl-design-system/components/icons/CloseOutlined';

import styles from './typeahead-overlay.scss';

interface CloseButtonProps {
  isTypeaheadOpen: boolean;
  onCloseButtonClick: () => void;
  isDesktopCloseButton: boolean;
  onTabOut?: () => void;
}

export const CloseButton = ({
  isTypeaheadOpen,
  onCloseButtonClick,
  isDesktopCloseButton,
  onTabOut = () => {},
}: CloseButtonProps) => {
  const closeButtonClasses = classNames([styles.bpCloseButton], {
    [styles.bpCloseButton__hidden]: !isTypeaheadOpen,
    [styles.bpCloseButton__desktop]: isDesktopCloseButton,
    [styles.bpCloseButton__mobile]: !isDesktopCloseButton,
  });

  return (
    <button
      data-testid={`close-expanded-search-${
        isDesktopCloseButton ? 'desktop' : 'mobile'
      }`}
      className={closeButtonClasses}
      onClick={onCloseButtonClick}
      onBlur={onTabOut}
    >
      <CloseOutlined className={styles.closeIcon} size="medium" />
      <span>Close</span>
    </button>
  );
};
